import React from 'react'
import { Link } from 'react-router-dom'
import { routes } from '../../../constants'
import { LoadingSpinner } from '../../../components/loadingSpinner/LoadingSpinner'
import './localizacao.scss'
import _ from 'lodash'

const MATRIZ_ESPACAMENTO = '5px'

export const LocalizacaoGridList = (props) => {
  const records = props.matriz ? props.matriz : []
  const tiposSepultura = props.tiposSepultura ? props.tiposSepultura : []
  for (let record of records) {
    for (let localizacao of record) {
      const tipoSepultura = tiposSepultura.find((t) => t.id === _.get(localizacao, 'oidTipoSepultura', null))
      if (tipoSepultura) {
        localizacao.tipoSepultura = tipoSepultura.object
      }
    }
  }
  const verde = '#7CB342' // Localizacao NAO Temporaria Disponivel OU Localizacao "Inexistente" mas disponivel para ser criada
  const cinza = '#cacaca' // Localizacao NAO Temporaria Indisponivel
  const branco = '#ffffff' //"#000000" "Espaco em branco"
  const azul = '#0066ff' // Localizacao Temporaria Indisponivel
  const amarelo = '#ffff00' // Localizacao Temporaria Disponivel
  const rosa = '#f48fb1' // Localizacao Inativa

  function isLocalizacaoInativa(localizacao) {
    return parseInt(_.get(localizacao, 'oid', null)) && _.get(localizacao, 'ativo', true) === false
  }

  function getColor(localizacao) {
    if (!localizacao || localizacao.sinalizador) {
      return branco
    }
    if (isLocalizacaoInativa(localizacao)) {
      return rosa
    }
    if (parseInt(localizacao.oid)) {
      if (localizacao.temporaria) {
        return localizacao.disponivel ? amarelo : azul
      }
      return localizacao.disponivel ? verde : cinza
    }
    return verde
  }

  function getTitle(localizacao) {
    if (!localizacao) {
      return ''
    }

    if (localizacao.sinalizador) {
      return localizacao.identificacao
    }

    if (isLocalizacaoInativa(localizacao)) {
      return 'Inativo: ' + localizacao.identificacao
    }

    if (parseInt(localizacao.oid)) {
      let title = localizacao.disponivel ? 'Disponível: ' : 'Indisponível: '
      return title + localizacao.identificacao
    }
    return 'Disponível'
  }

  function getLink(localizacao) {
    return (
      <Link
        style={{
          backgroundColor: getColor(localizacao),
          boxSizing: 'border-box',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          minWidth: 0,
          minHeight: 0,
          flex: '1 1 auto',
          padding: '8px 15px',
          fontVariantNumeric: 'tabular-nums',
        }}
        to={resolveRota(localizacao)}
      >
        {_.get(localizacao, 'idDisplay', '')}
      </Link>
    )
  }

  function resolveRota(localizacao) {
    if (!localizacao || localizacao.sinalizador) {
      return {
        // pathname: `${routes.PATH_LOCALIZACAO}/novo`,
        // localizacaoRef: null
      }
    }
    if (props.onClickLocalizacaoSepultamento) {
      return {
        pathname: '',
        localizacaoRef: '',
      }
    }
    if (isLocalizacaoInativa(localizacao)) {
      return {
        pathname: `${routes.PATH_LOCALIZACAO}/${localizacao.oid}`,
      }
    }
    if (parseInt(localizacao.oid) && localizacao.disponivel) {
      return {
        pathname: `${routes.PATH_CONTRATO}/novo`,
        localizacaoRef: localizacao,
      }
    }
    if (parseInt(localizacao.oid) && parseInt(localizacao.oidContrato)) {
      return {
        pathname: `${routes.PATH_CONTRATO}/${localizacao.oidContrato}`,
        localizacaoRef: null,
      }
    } else if (parseInt(localizacao.oid) && parseInt(localizacao.oidContratoFalecido)) {
      return {
        pathname: `${routes.PATH_CONTRATO}/${localizacao.oidContratoFalecido}`,
        localizacaoRef: null,
      }
    }

    localizacao.oid = '__' + Math.random()
    return {
      pathname: `${routes.PATH_CONTRATO}/${localizacao.oid}`,
      localizacaoRef: localizacao,
    }
  }

  function renderMatriz(records) {
    const numCols = records.length ? Math.max(...records.map((row) => row.length)) : 0
    const gridCols = numCols ? `repeat(${numCols}, minmax(0, 1fr))` : undefined

    return (
      <div id="scrollDiv" style={{ marginLeft: '10px' }}>
        <div
          style={{
            display: 'grid',
            width: 'max-content',
            gridTemplateColumns: gridCols,
            gap: MATRIZ_ESPACAMENTO,
          }}
        >
          {records.map((row, i) => {
            const cells = row.slice()
            while (cells.length < numCols) {
              cells.push(null)
            }
            return (
              <div
                key={i}
                style={{
                  display: 'grid',
                  gridTemplateColumns: 'subgrid',
                  gridColumn: '1 / -1',
                  alignItems: 'stretch',
                }}
              >
                {cells.map((col, j) => (
                  <span
                    key={j}
                    style={{
                      minWidth: 0,
                      minHeight: 0,
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'stretch',
                    }}
                    title={col ? getTitle(col) : undefined}
                    onClick={(e) =>
                      col && props.onClickLocalizacaoSepultamento ? props.onClickLocalizacaoSepultamento(col) : ''
                    }
                  >
                    {col ? getLink(col) : null}
                  </span>
                ))}
              </div>
            )
          })}
        </div>
      </div>
    )
  }

  if ((!records || records.length === 0) && !props.showSpinner) {
    return null
  } else if (props.showSpinner) {
    return <LoadingSpinner />
  } else {
    return renderMatriz(records)
  }
}
